// extracted by mini-css-extract-plugin
module.exports = {"btn-submit":"formLogin_btn-submit__1NXNf","field-group":"formLogin_field-group__2nbbA","form":"formLogin_form__3xjAN"};